import { handleActions } from 'redux-actions'
import { expandedUserType, resetExpanded } from 'actions/expandedUserType'

const defaultState = {
  expandedUserType: ''
}

const reducer = handleActions(
  {
    [expandedUserType]: (
      state,
      {
        payload: {
          data: { status }
        }
      }
    ) => status,
    [resetExpanded]: () => defaultState
  },
  defaultState
)

export default reducer
